import registerExtensions from './register-extensions';

export default {
  registerExtensions,
};
